
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { formatDateTime } from "@/utils/admin-utils";

interface CancellationRequestsTabProps {
  requests: any[];
  onAction: (requestId: string, bookingId: string, action: 'approve' | 'reject') => void;
}

export const CancellationRequestsTab = ({ requests, onAction }: CancellationRequestsTabProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Cancellation Requests</CardTitle>
        <CardDescription>Manage booking cancellation requests</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {requests.length === 0 ? (
            <p className="text-gray-500">No cancellation requests found.</p>
          ) : (
            requests.map((request) => (
              <Card key={request.id} className="p-4">
                <div className="space-y-2">
                  <div className="flex justify-between items-start">
                    <div>
                      <h3 className="font-semibold">
                        {request.profiles.first_name} {request.profiles.last_name}
                      </h3>
                      <p className="text-sm text-gray-500">
                        {request.bookings.parking_spot.address}
                      </p>
                    </div>
                    <span className={`px-2 py-1 rounded-full text-xs ${
                      request.status === 'pending' ? 'bg-yellow-100 text-yellow-800' :
                      request.status === 'approved' ? 'bg-green-100 text-green-800' :
                      'bg-red-100 text-red-800'
                    }`}>
                      {request.status.charAt(0).toUpperCase() + request.status.slice(1)}
                    </span>
                  </div>
                  <div className="text-sm">
                    <p><strong>Booking Time:</strong> {formatDateTime(request.bookings.start_time)} - {formatDateTime(request.bookings.end_time)}</p>
                    <p><strong>Reason:</strong> {request.reason}</p>
                    <p className="text-gray-500 text-xs">Requested on: {formatDateTime(request.created_at)}</p>
                  </div>
                  {request.status === 'pending' && (
                    <div className="flex gap-2 justify-end mt-4">
                      <Button
                        variant="outline"
                        onClick={() => onAction(request.id, request.bookings.id, 'reject')}
                      >
                        Reject
                      </Button>
                      <Button
                        variant="destructive"
                        onClick={() => onAction(request.id, request.bookings.id, 'approve')}
                      >
                        Approve Cancellation
                      </Button>
                    </div>
                  )}
                </div>
              </Card>
            ))
          )}
        </div>
      </CardContent>
    </Card>
  );
};
